import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
import { CheckList } from "../CheckList";
import { guaranteeItems } from "../../data/content";
export function GuaranteeSection() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-187" data-mp="1kaayluap5o04">
      <div className="mx-auto max-w-3xl" data-id="element-188" data-mp="1fdatbllo8pa2">
        <div className="rounded-3xl bg-cta-soft p-6 ring-2 ring-cta sm:p-10" data-id="element-189" data-mp="1fc9ct1lvzaky">
          <div className="flex flex-col items-center text-center" data-id="element-190" data-mp="1aer7dl72vdhp">
            <div className="relative flex h-32 w-32 flex-col items-center justify-center rounded-full bg-navy ring-4 ring-gold ring-offset-4 ring-offset-cta-soft" data-id="element-191" data-mp="15euyb7jiwvva">
              <ShieldCheckIcon className="h-8 w-8 text-gold" aria-hidden="true" data-id="element-192" data-mp="11f41on7bfliu" />
              <span className="mt-1 text-3xl font-extrabold leading-none text-white" data-id="element-193" data-mp="wfhoueveg7ak">7-Day</span>
              <span className="text-[11px] font-bold uppercase tracking-wider text-brand-sky" data-id="element-194" data-mp="2vqitranstx1r">Guarantee</span>
            </div>
            <h2 className="mt-7 text-[1.8rem] font-extrabold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-195" data-mp="2qq3hkmf96vld">
              Explore the Blueprint™ and decide whether it meets your expectations
            </h2>
          </div>

          <div className="mt-6 space-y-4 text-base leading-relaxed text-ink sm:text-lg" data-id="element-196" data-mp="174ou7fzjlcnj">
            <p data-id="element-197" data-mp="1c2yozphcub8m">I want you to understand exactly what you’re receiving when you purchase this educational collection.</p>
            <p data-id="element-198" data-mp="1zskpqhddkyiq">
              You’ll have <strong data-id="element-199" data-mp="1ztck5ov8kq7f">seven days</strong> to explore the material and determine whether it meets the expectations described
              on this page. During that time, you can review:
            </p>
          </div>

          <div className="mt-5 rounded-2xl bg-white p-5" data-id="element-200" data-mp="1q0x44x3i2bp6">
            <CheckList items={guaranteeItems} columns data-id="element-201" data-mp="1v12nzr3j2twp" />
          </div>

          <div className="mt-6 space-y-4 text-base leading-relaxed text-ink sm:text-lg" data-id="element-202" data-mp="2iryl93qr6hbc">
            <p data-id="element-203" data-mp="2nif10ui1qf0v">
              If the product doesn’t meet the expectations described in the offer, you can request a refund within the seven-day period
              under the published refund terms.
            </p>
            <p className="font-semibold" data-id="element-204" data-mp="2serh57g7z52p">My goal is to provide an organized educational resource that delivers the value you expect.</p>
          </div>
        </div>

        <SectionCta label="Get the Blueprint™ with the 7-day guarantee" note="Risk-free · Seven-day satisfaction guarantee" data-id="element-205" data-mp="2niap425wg6kc" />
      </div>
    </section>;
}